import {ConnectedPlatforms, ExternalAuths, Options} from '../../utils/types';

import ConfirmNextSection from './RedeemSectionPsnConfirmNext';
import PsnCountryDropDown from './RedeemSectionPsnCountryDropDown';
import React from 'react';

interface Props {
  enableRegionAutoDetection: boolean;
  externalAuths: ExternalAuths[];
  psnCountry: string;
  psnToolTip: string;
  countries: Options[];
  connectedPlatforms: ConnectedPlatforms[];
}

const PsnCountryContainer = ({
  enableRegionAutoDetection,
  externalAuths,
  countries,
  psnToolTip,
  psnCountry,
  connectedPlatforms,
}: Props) => {
  if (enableRegionAutoDetection) {
    return (
      <ConfirmNextSection externalAuths={externalAuths} connectedPlatforms={connectedPlatforms} />
    );
  }
  return (
    <PsnCountryDropDown psnCountry={psnCountry} countries={countries} psnToolTip={psnToolTip} />
  );
};

export default PsnCountryContainer;
